<template>
    <v-form v-model="valid" ref="form" @submit.prevent="submit">
        <v-card>
            <v-card-text>
                <!-- Basic Info -->
                <div class="subheading mb-3">{{ $t("label.basicInfo") }}</div>
                <v-layout row>
                    <v-flex xs3 lg2>
                        <label class="form-label"
                            >{{ $t("label.estimatedQuantity") }}*</label
                        >
                    </v-flex>
                    <v-flex xs2 lg2>
                        <v-text-field
                            :disabled="disabled"
                            v-model.number="form.plannedTime"
                            :suffix="unit"
                            :rules="validation.requiredNumeric"
                            :maxlength="constants.LENGTH_PLANNED_TIME"
                        ></v-text-field>
                    </v-flex>
                </v-layout>
                <v-layout row>
                    <v-flex xs3 lg2>
                        <label class="form-label"
                            >{{ $t("label.deliveryDate") }}*</label
                        >
                    </v-flex>
                    <v-flex xs2 lg2>
                        <app-menu-date-picker
                            :model.sync="form.deliveryDate"
                            :disabled="disabled"
                            :label="$t('label.deliveryDate')"
                            :rules="validation.required"
                        ></app-menu-date-picker>
                    </v-flex>
                </v-layout>
                <v-layout row>
                    <v-flex xs3 lg2>
                        <label class="form-label">{{
                            $t("label.usedTime")
                        }}</label>
                    </v-flex>
                    <v-flex xs2 lg2>
                        <v-text-field
                            :disabled="disabledExecutedTime"
                            v-model.number="form.executedTime"
                            :suffix="unit"
                            :mask="validation.mask.executedTime"
                        ></v-text-field>
                    </v-flex>
                </v-layout>

                <!-- Details -->
                <div class="subheading mt-3">{{ $t("label.details") }}</div>
                <p v-html="$t('message.info.demandDeliveryDetails')"></p>
                <v-layout row>
                    <v-flex xs3 lg2>
                        <label class="form-label">{{
                            $t("label.description")
                        }}</label>
                    </v-flex>
                    <v-flex xs9 lg10>
                        <v-text-field
                            multi-line
                            :disabled="disabledExecutedTime"
                            v-model="form.description"
                            auto-grow
                            :counter="constants.LENGTH_DESCRIPTION"
                            :maxlength="constants.LENGTH_DESCRIPTION"
                        ></v-text-field>
                    </v-flex>
                </v-layout>

                <!-- Files -->
                <v-layout row v-show="form.files.length > 0" class="mt-3">
                    <v-flex xs9 lg10 offset-xs3 offset-lg2>
                        <app-files
                            :files.sync="form.files"
                            :removedFiles.sync="form.removedFiles"
                            :removeable="!disabled"
                        ></app-files>
                    </v-flex>
                </v-layout>
            </v-card-text>

            <v-card-actions v-if="!disabled">
                <v-btn @click="save" 
                :loading="saving" 
                :disabled="desabilitaRequestApproval"
                color="primary">{{
                    $t("label.requestApproval")
                }}</v-btn>
                <app-file-upload
                    :disabled="saving"
                    :model.sync="form.files"
                ></app-file-upload>
            </v-card-actions>
        </v-card>

    </v-form>

</template>

<script>
import constants from "@/helpers/constants";
import utilities from "@/helpers/utilities";
import validation from "@/helpers/validation";

import FileUpload from "@/components/shared/FileUpload";
import Files from "@/components/shared/Files";
import MenuDatePicker from "@/components/shared/MenuDatePicker";
import Demand from "@/helpers/entities/Demand";

export default {
    data() {
        return {
            constants,
            validation,
            valid: true,
            saving: false,

            form: Demand.delivery.build()
        };
    },

    computed: {
        demand() {
            return this.$store.getters.demand;
        },
        disabled() {
            return (
                !(this.demand.status.id === constants.STATUS_DELIVERY) ||
                !utilities.isDemandActionable(
                    this.$store.getters.profile,
                    this.demand.owner,
                    this.demand.status,
                    constants.STATUS_DELIVERY
                )
            );
        },
        desabilitaRequestApproval() {
            return (
                this.demand.status.id === constants.STATUS_DELIVERY &&
                this.demand.supplier.id === 1
            );
        },
        disabledExecutedTime() {
            const hasDisabled =
                !(this.demand.status.id === constants.STATUS_DELIVERY) ||
                !utilities.isDemandActionable(
                    this.$store.getters.profile,
                    this.demand.owner,
                    this.demand.status,
                    constants.STATUS_DELIVERY
                );

            return hasDisabled;
        },
        unit() {
            const id = (this.demand.contract || {}).id;
            return !id
                ? ""
                : this.$store.getters.contractsDictionary[
                      id
                  ].unit.name.toLowerCase();
        },
    },
    components: {
        appFileUpload: FileUpload,
        appFiles: Files,
        appMenuDatePicker: MenuDatePicker
    },
    watch: {
        demand: "copyToForm"
    },
    methods: {
        async save() {
            if (!this.$refs.form.validate()) return;

            this.saving = true;
            await this.$store.dispatch(
                "deliverDemand",
                Demand.delivery.prepare(this.form)
            );
            this.$router.push({ name: "dashboard" });
        },

        copyToForm(demand) {
            this.form = Demand.delivery.copy(demand);
            this.form.plannedTime =
                this.form.plannedTime || this.demand.estimatedTime;
        }
    }
};
</script>


// WEBPACK FOOTER //
// src/components/demands/steps/Delivery.vue